import { createInstance } from '@optimizely/react-sdk';

import { OPTIMIZELY_SDK_KEY } from '../envConfig';

import { withFlagSuppression } from './flagSuppression';

// Initialize Optimizely client once - exported for direct access in hooks.
// withFlagSuppression forces every flag off for the deny-listed bug-bounty org
// (a no-op unless FEATURE_FLAGS_DISABLED_IDS is set); see
// docs/tech-spec/bug-crowd-feature-flag-suppression.md.
export const optimizelyClient = withFlagSuppression(
  createInstance({
    sdkKey: OPTIMIZELY_SDK_KEY,
    logLevel: 'error',
  })
);
